import StatCard from "../../components/StatCard";
import { StatSummary } from "../../components/StatSummary";
import useMemberDashboardSummary from "../../hooks/use-member-dashboard-summary";
import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import theme from "../../app/app-theme";
import thumbsUpImage from "../../resources/images/emoji/thumbs-up.png";
import { AttendanceIcon, ChecklistIcon, HourglassIconBottom, MessageIcon } from "../../shared/icons";

const MemberDashboard = () => {
    const summary = useMemberDashboardSummary();

    const isExpired = (dueDate: string) => {
        const today = new Date();
        const expiry = new Date(dueDate);

        return expiry.getTime() < today.getTime();
    }

    return (
        <>
            {summary &&
                <>
                    <StatSummary>
                        <StatCard title="Expiry Date" value={summary?.expiryDate} icon={HourglassIconBottom} />
                        <StatCard title="Last 4 Weeks Attendance" value={summary?.daysAttendedInLast28Days} icon={AttendanceIcon} />
                        <StatCard title="Open Notes" value={summary?.openNoteCount} icon={ChecklistIcon} />
                        <StatCard title="Messages Received Today" value={summary?.messagesReceivedToday} icon={MessageIcon} />
                    </StatSummary>
                    <Grid container direction="row" justifyContent="flex-start">
                        <Grid size={{ lg: 3, xs: 12 }}>
                            <Card style={{ marginTop: "12px", padding: 12, backgroundColor: theme.palette.primary.contrastText, height: "290px", overflowY: "auto" }}>
                                <h3 style={{ justifySelf: "center" }}>
                                    My Notes {summary?.openNotes.length > 0 ? `(${summary?.openNotes.length})` : "(0)"}
                                </h3>
                                <>
                                    {summary?.openNotes?.map(note =>
                                        <Stack spacing={2} sx={{ flexGrow: 1, m: 2 }} key={note.noteId}>
                                            <Card sx={{ width: "100%" }} style={{ border: `1px solid ${theme.palette.primary.main}` }}>
                                                <CardContent style={{ padding: "8px" }}>
                                                    <Typography variant="body1" component="div">
                                                        {note.content}
                                                    </Typography>
                                                    <Typography gutterBottom sx={{ color: `${isExpired(note.dueDate) ? theme.palette.error.main : 'text.secondary'}`, fontSize: 14, m: 0 }}>
                                                        {note.dueDate && `Due: ${note.dueDate}`}
                                                    </Typography>
                                                    <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14, m: 0 }}>
                                                        {note.createdOn && `Created On: ${note.createdOn.replace('T', ' ').substring(0, 16)}`}
                                                    </Typography>
                                                </CardContent>
                                            </Card>
                                        </Stack>
                                    )}
                                    {summary?.openNotes.length === 0 &&
                                        <>
                                            <Typography style={{ textAlign: "center", fontStyle: "italic" }}>No Open Tasks</Typography>
                                            <img src={thumbsUpImage} style={{ maxWidth: "100%", maxHeight: "200px", display: "block", margin: "0 auto" }} alt="" />
                                        </>
                                    }
                                </>
                            </Card>
                        </Grid>
                        {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                            <ChartCard><SingleBarChart data={summary.dailyAttendanceTrend.map(item => { return { name: item.key, value: item.value } })} label='Daily Attendance' height={204} xAxisInterval={7}/></ChartCard>
                        </Grid>
                        <Grid item lg={3} md={6} sm={12} xs={12}>
                            <ChartCard><DoughnutChart data={summary.countByStatus.map(item => { return { name: item.key, value: item.value } })} label='Membership Status' /></ChartCard>
                        </Grid> */}
                    </Grid>
                </>
            }
        </>
    )
}

export default MemberDashboard;